import { BLACK, PRIMARY_PURPLE } from '../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../theme/fontConstants';

const styles = {
  bgColor: BLACK[0],
  iconButtonColor: BLACK[50],
  title: {
    fontFamily: PRIMARY_FONT[700],
    fontSize: '24px',
    fontColor: BLACK[100],
  },
  infoText: {
    fontFamily: PRIMARY_FONT[400],
    fontSize: '14px',
    fontColor: BLACK[100],
  },
  noDataText: {
    fontFamily: PRIMARY_FONT[500],
    fontSize: '20px',
    fontColor: BLACK[20],
  },
  checkbox: {
    color: PRIMARY_PURPLE[40],
    fontFamily: PRIMARY_FONT[400],
    fontSize: '16px',
  },
};

export default styles;
